import { render, staticRenderFns } from "./BlogPost.vue?vue&type=template&id=d6ac7f46&scoped=true&"
import script from "./BlogPost.vue?vue&type=script&lang=js&"
export * from "./BlogPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ac7f46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6ac7f46')) {
      api.createRecord('d6ac7f46', component.options)
    } else {
      api.reload('d6ac7f46', component.options)
    }
    module.hot.accept("./BlogPost.vue?vue&type=template&id=d6ac7f46&scoped=true&", function () {
      api.rerender('d6ac7f46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Blog/BlogPost.vue"
export default component.exports